// Format any ISO datetime in UAE (Asia/Dubai, GST UTC+4) since the company is UAE-based.

const UAE_TZ = "Asia/Dubai";
const LOCALE = "en-GB"; // dd Mmm, HH:mm format

export function fmtUAE(iso, opts = {}) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString(LOCALE, {
      timeZone: UAE_TZ,
      weekday: "short",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      ...opts,
    });
  } catch {
    return iso;
  }
}

export function fmtUAEShort(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString(LOCALE, {
      timeZone: UAE_TZ,
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return iso;
  }
}

export function fmtUAEDateOnly(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString(LOCALE, {
      timeZone: UAE_TZ,
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export const TZ_LABEL = "GST"; // Gulf Standard Time
